<template>
  <b-modal ref="fuel-tank-card-modal" @ok="fuelTankModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.fuelTankCard.headerLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-tabs>
        <FuelTankCardMainTab
          v-bind:fuelTankCard="fuelTankCard"
          v-bind:fuelDepos="fuelDepos"
        ></FuelTankCardMainTab>
        <FuelLevelSensorTab
          ref="fuel-level-sensor-tab"
          v-bind:fuelTankCard="fuelTankCard"
        ></FuelLevelSensorTab>
        <FuelCounterTab
          ref="fuel-counter-tab"
          v-bind:fuelTankCard="fuelTankCard"
        ></FuelCounterTab>
        <FuelDensitySensorTab
          ref="fuel-density-sensor-tab"
          v-bind:fuelTankCard="fuelTankCard"
        ></FuelDensitySensorTab>
        <WaterLevelSensorTab
          ref="water-level-sensor-tab"
          v-bind:fuelTankCard="fuelTankCard"
        ></WaterLevelSensorTab>
        <NotificationSettingsTab
          ref="notification-settings-tab"
          v-bind:fuelTankCard="fuelTankCard"
        ></NotificationSettingsTab>
      </b-tabs>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button
        variant="success"
        style="font-size: 12px"
        :disabled="
          $store.state.authentication.roles.indexOf(
            FUEL_TANK_CARD_UPDATE_ROLE
          ) == -1
        "
        @click="ok()"
        >{{ $store.state.localization.data.common.table.ok }}</b-button
      >
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>
import FuelTankCardMainTab from "./MainTab.vue";
import FuelLevelSensorTab from "./FuelLevelSensorTab.vue";
import FuelCounterTab from "./FuelCounterTab.vue";
import NotificationSettingsTab from "./NotificationSettingsTab.vue";
import FuelDensitySensorTab from "./FuelDensitySensorTab.vue";
import WaterLevelSensorTab from "./WaterLevelSensorTab.vue";
import { roleService, fuelTankService } from "../../../services";

export default {
  name: "FuelTankCard",
  components: {
    FuelTankCardMainTab,
    FuelLevelSensorTab,
    FuelCounterTab,
    FuelDensitySensorTab,
    WaterLevelSensorTab,
    NotificationSettingsTab,
  },
  data() {
    return {
      fuelTankCard: {},
      fuelDepos: [],
      FUEL_TANK_CARD_UPDATE_ROLE: roleService.FUEL_TANK_CARD_UPDATE_ROLE,
    };
  },
  methods: {
    async open(fuelTankCard, fuelDepos) {
      this.fuelTankCard = fuelTankCard;
      this.fuelDepos = fuelDepos;

      this.$refs["fuel-tank-card-modal"].show();
    },
    async fuelTankModalOk(event) {
      if (!this.$refs["fuel-counter-tab"].validate()) {
        event.preventDefault();
        return;
      }

      if (!this.$refs["fuel-density-sensor-tab"].validate()) {
        event.preventDefault();
        return;
      }

      const fuelTankCard = {
        vehicleId: this.fuelTankCard.vehicleId,
        sensorId: this.fuelTankCard.sensorId,
        name: this.fuelTankCard.name,
        description: this.fuelTankCard.description,
        fuelDepoId: this.fuelTankCard.fuelDepoId,
        note: this.fuelTankCard.note,
        additionalInfo: this.fuelTankCard.additionalInfo,
        minBeginFuelCharge: parseInt(this.fuelTankCard.minBeginFuelCharge),
        maxEndFuelCharge: parseInt(this.fuelTankCard.maxEndFuelCharge),
        minFuelCharge: parseInt(this.fuelTankCard.minFuelCharge),
        minBeginFuelDischarge: parseInt(this.fuelTankCard.minBeginFuelDischarge),
        maxEndFuelDischarge: parseInt(this.fuelTankCard.maxEndFuelDischarge),
        minFuelDischarge: parseInt(this.fuelTankCard.minFuelDischarge),
        tankVolume: parseFloat(this.fuelTankCard.tankVolume),
        tankHeight: parseInt(this.fuelTankCard.tankHeight),
        tankType: this.fuelTankCard.tankType,
        maxFuelHeight: parseInt(this.fuelTankCard.maxFuelHeight),
        minFuelHeight: parseInt(this.fuelTankCard.minFuelHeight),
        maxWaterHeight: parseInt(this.fuelTankCard.maxWaterHeight),
        minWaterHeight: parseInt(this.fuelTankCard.minWaterHeight),
        fuelDensity: parseFloat(this.fuelTankCard.fuelDensity),
        fuelTypeId: parseInt(this.fuelTankCard.fuelTypeId),
        identifier: this.fuelTankCard.identifier,
        networkAddress: this.fuelTankCard.networkAddress,
        fuelLevelCorrection: parseInt(this.fuelTankCard.fuelLevelCorrection),
        waterLevelCorrection: parseInt(this.fuelTankCard.waterLevelCorrection),
        notificationSettings:
          this.$refs["notification-settings-tab"].getNotificationSettings(),
        fuelTankConsumptionInfos: await this.$refs[
          "fuel-counter-tab"
        ].getFuelTankConsumptionInfos(),
      };

      const sensorVerificationNumber =
        this.$refs["fuel-level-sensor-tab"].getSensorVerificationNumber();

      if (sensorVerificationNumber) {
        fuelTankCard.sensorVerificationNumber = sensorVerificationNumber;
      }

      const sensorVerificationDate =
        this.$refs["fuel-level-sensor-tab"].getSensorVerificationDate();

      if (sensorVerificationDate) {
        fuelTankCard.sensorVerificationDate = sensorVerificationDate;
      }

      const sensorVerificationFile =
        this.$refs["fuel-level-sensor-tab"].getSensorVerificationFileName();

      if (sensorVerificationFile) {
        fuelTankCard.sensorVerificationFileName = sensorVerificationFile;
        fuelTankCard.sensorVerificationFile = await this.$refs[
          "fuel-level-sensor-tab"
        ].getSensorVerificationFile();
      }

      const sensorFuelDensitySettings = this.$refs["fuel-density-sensor-tab"].getSensorSettings();
      fuelTankCard.densitySensorInput = sensorFuelDensitySettings.sensorInput;
      fuelTankCard.densitySensorInitDensity = parseFloat(sensorFuelDensitySettings.initDensity);
      fuelTankCard.densitySensorInitLevel = parseInt(sensorFuelDensitySettings.initLevel);
      fuelTankCard.densitySensorStep = parseInt(sensorFuelDensitySettings.step);
      
      const sensorWaterLevelSettings = this.$refs["water-level-sensor-tab"].getSensorSettings();
      fuelTankCard.waterSensorInput = sensorWaterLevelSettings.sensorInput;

      const response = await fuelTankService.updateFuelTankCard(fuelTankCard);

      if (response.isSuccess) {
        if (response.data.countUpdatedRows == 1) {
          if (response.data.isActiveMqMessageSent) {
             alert(this.$store.state.localization.data.mainPage.fuelTankCard.fuelTankCardUpdateSuccess);
            } else {
              alert(this.$store.state.localization.data.mainPage.fuelTankCard.fuelTankCardUpdateError2);
            }
          } else {
            alert(this.$store.state.localization.data.mainPage.fuelTankCard.fuelTankCardUpdateError);
          }
        } else {
          alert(this.$store.state.localization.data.mainPage.fuelTankCard.fuelTankCardUpdateError);
      }
    },
  },
};
</script>
